import { Hidden } from '@patrianna/core-components'
import cx from 'classnames'

import MenuDesktop from 'containers/Menu/MenuDesktop'
import MenuMobile from 'containers/Menu/MenuMobile'
import { useAppSelector } from 'store/hooks'
import { shouldForceVerifyKYCSelector } from 'store/modules/user/selectors'

import MenuTrigger from './MenuTrigger'
import classes from './styles.module.scss'

type Props = {
  toggleMenu: () => void
  isMobile?: boolean
  menuHidden?: boolean
  triggerHidden?: boolean
}

export default function Menu(props: Props) {
  const isForceShowKYC = useAppSelector(shouldForceVerifyKYCSelector)

  return (
    <>
      <div
        className={cx(classes.menuDesktop, props.menuHidden && classes.menuDesktopCollapse, {
          [classes.disabled]: isForceShowKYC,
        })}
      >
        <Hidden visibleFor='mobile'>
          <MenuDesktop />
          {!props.triggerHidden && <MenuTrigger toggleMenu={props.toggleMenu} menuHidden={props.menuHidden} />}
        </Hidden>
      </div>
      <MenuMobile isMobile={props.isMobile} />
    </>
  )
}
